import { create } from 'zustand';

const useWindowStore = create((set) => ({
  // State
  windowWidth: null,
  windowHeight: null,
  isMobile: false,

  // Actions
  setWindowDimensions: (width, height) => set({
    windowWidth: width,
    windowHeight: height,
    isMobile: width < 768,
  }),
}));

export default useWindowStore;
